import useLocalStorageState from 'use-local-storage-state'
import { z } from 'zod'

const LOCAL_STORAGE_NAME = 'granule-pod-lupou-compare'

export function useComparator() {
	const [productsInComparator, setProductsInComparator, { removeItem }] = useLocalStorageState<string[]>(
		LOCAL_STORAGE_NAME,
		{
			defaultValue: [],
		},
	)

	const addProduct = (id: string) => {
		setProductsInComparator([...productsInComparator, id])
	}

	const removeAll = () => {
		removeItem()
	}

	const removeById = (id: string) => {
		const savedToCompare = localStorage.getItem(LOCAL_STORAGE_NAME)

		const toSave = savedToCompare
			? z
					.array(z.string())
					.parse(JSON.parse(savedToCompare))
					.filter((item) => item !== id)
			: []

		localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(toSave))

		setProductsInComparator(toSave)
	}

	return { addProduct, removeById, removeAll, productsInComparator }
}
